/* eslint-disable react/jsx-props-no-spreading, react/jsx-no-target-blank */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage, useIntl } from 'react-intl';

import FMCIcon from '../icons/FMC';
import UrbaniaIcon from '../icons/Urbania';

import styles from '../../../styles/partials/footer.module.scss';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const Footer = ({ className }) => {
    const { locale } = useIntl();

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.credits}>
                <div className={styles.text}>
                    <FormattedMessage
                        defaultMessage="A product by"
                        description="Contact footer content"
                    />
                </div>
                <a href="https://urbania.ca" target="_blank">
                    <UrbaniaIcon className={styles.logo} />
                </a>
            </div>
            <div className={styles.partners}>
                <div className={styles.text}>
                    <FormattedMessage
                        defaultMessage="The Micromag platform was supported thanks to the financial contribution of"
                        description="Contact footer content"
                    />
                </div>
                <FMCIcon className={styles.logo} fr={locale === 'fr'} />
            </div>
        </div>
    );
};

Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps;

export default Footer;
